export const BAN_WORDS = 'contain ban words';
export const LIMIT_PER_WEEK = 'number of sale limit per week exceeded';
export const INAPPROPRIATE_IMAGE = 'contain inappropriate images';
export const HUMAN_IMAGE = 'contain human images';
export const DENIAL_FISH_IMAGE = 'contain denial fish images';
export const UNCONTAIN_FISH_IMAGE = 'uncontain fish images';
